module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/5FGA99OERH4vFguC2EhGsC-5aa708b8fe978faac71e223c91b5e267.jpg";